import { Grid } from "@mui/material";
import React from "react";
import "./creator.css";
import CreatorCardOne from "./CreatorCardOne";
import MultipleItems from "./CreatorSlider";
import PopularC from "./PopularC";

function Creator() {
  return (
    <div className="creator_main">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10}>
          {/* HEADING GRID */}
          <Grid
            container
            sx={{
              justifyContent: {
                xs: "center",
                sm: "center",
                md: "space-around",
                lg: "space-between",
              },
            }}
            alignItems="center"
          >
            <Grid item xs={10} md={6} lg={6}>
              <h1 className="creator_heading">Popular Creator</h1>
              <p className="creator_para">
                I make art with the simple goal of giving you something pleasing
                to look at for a few seconds.
              </p>
              <br />
            </Grid>
            <Grid item lg={3} className="center_flex">
              <button className="common_btn">Be one of our Creator</button>
            </Grid>
          </Grid>
          {/*  */}
          <CreatorCardOne />
          {/*  */}
          {/*  */}
          <PopularC />
          {/*  */}

          {/* HEADING GRID */}
        </Grid>
      </Grid>
      <Grid container justifyContent="center">
        <Grid item xs={11.5} lg={11}>
          {/*  */}
          <MultipleItems />
          {/*  */}
        </Grid>
      </Grid>
      <div className="seprator"></div>
      <div className="seprator"></div>
      <div className="seprator"></div>
    </div>
  );
}

export default Creator;
